export default function Sparkline({
  values, width=280, height=48, strokeWidth=2
}:{ values:number[], width?:number, height?:number, strokeWidth?:number }){
  if (!values.length) return <svg width={width} height={height}/>
  const min = Math.min(...values)
  const max = Math.max(...values)
  const rng = max - min || 1
  const pts = values.map((v,i)=>{
    const x = (i/(values.length-1))*width
    const y = height - ((v - min)/rng)*height
    return `${x},${y}`
  }).join(' ')
  return (
    <svg width={width} height={height}>
      <polyline
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        points={pts}
      />
    </svg>
  )
}
